import {Observable} from 'rxjs';
import {palipaliAPI} from '../provider/palipaliAPI';
import {RestQueryParams} from '../base/queryParams';
import {IApiResponseBase, IRawRestQueryParams} from '../../types';
import {ILocationOutput} from '../../model/location';

export function getLocationListAPI(
    authToken: string,
    payload?: any,
    params?: IRawRestQueryParams | []
): Observable<IApiResponseBase<ILocationOutput[]>> {
    return palipaliAPI.get('api/locations', new RestQueryParams(params), {
        Authorization: `Bearer ${authToken}`,
    });
}
